import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'

export function fulfilled(state, payload, result) {
  const kapitelId = (result && result.kapitelId) || payload.kapitelId
  const frageId = (result && result.frageId) || payload.frageId
  const kommentar = (result && result.kommentar) || {
    authorId: payload.authorId,
    text: payload.text,
  }
  const existingKapitelAnswers = state.answers[kapitelId] || {}
  const existingQuestionAnswers = existingKapitelAnswers[frageId] || {}

  return {
    ...state,
    answers: {
      ...state.answers,
      [kapitelId]: {
        ...existingKapitelAnswers,
        [frageId]: {
          ...existingQuestionAnswers,
          ...(result || {}),
          kommentar: {
            ...kommentar,
          },
        },
      },
    },
    isLoading: false,
  }
}

export function pending(state) {
  return {
    ...state,
    isLoading: true,
  }
}

export function rejected(state) {
  return {
    ...state,
    isLoading: false,
  }
}

export async function action(payload) {
  try {
    return await Api.postComment(payload.azubiId, payload.kapitelId, payload.frageId, payload.text)
  } catch (e) {
    actions.error.writeError({error: e, errorMessage: i18n.t('ausbildungsplan_save_comment_error')})
    throw new Error(i18n.t(e.message))
  }
}
